<template lang="pug">

  transition(
    @enter="enter"
    @leave="leave"
    :css="false" 
  )

    nav#pagination(v-show="show" aria-label="Pagination")
      star-btn(ref="dotOne" :star_index="1" @navigate="onNavigate").button
      star-btn(ref="dotTwo" :star_index="2" @navigate="onNavigate").button
      star-btn(ref="dotThree" :star_index="3" @navigate="onNavigate").button
      star-btn(ref="dotFour" :star_index="4" @navigate="onNavigate").button
      star-btn(ref="dotFive" :star_index="5" @navigate="onNavigate").button
      star-btn(ref="dotSix" :star_index="6" @navigate="onNavigate").button

</template>

<script>

import { mapState, mapMutations, mapGetters } from 'vuex'
import { PATHS, HOME, MODAL_STATES } from '@/config/app'
import { map } from '@/helpers/MathUtils'
import StarBtn from '@/components/home/Pagination/dot'

export default {

  components: {
    StarBtn
  },

  data() {
    return {}
  },

  computed: {

    ...mapState('app', [
      'home',
      'modal_state',
      'motion_clamp'
    ]),

    show(){

      let isIndexFirst = this.home.section_index === 0
      let isIndexLast = this.home.section_index === ( this.home.sections.length - 1 )
      let isHomeRoute = this.$route.name === PATHS.HOME
      let isDefaultModalState = (this.modal_state === MODAL_STATES.NONE)
      let show = (
        !isIndexFirst &&
        // !isIndexLast &&
        isHomeRoute &&
        isDefaultModalState
      )
 
      return show
    }
  },

  created(){ },

  mounted() {
  },

  beforeDestroy() {},

  methods: {

    ...mapMutations('app', [
      'setHomeSectionByIndex',
      'setModalState'
    ]),

    onNavigate( index ){
      this.setHomeSectionByIndex( index )
    },

    enter(el, done){
      [
        this.$refs.dotOne,
        this.$refs.dotTwo,
        this.$refs.dotThree,
        this.$refs.dotFour,
        this.$refs.dotFive,
        this.$refs.dotSix
      ].forEach((dot, i) => {
        let delay = 1.5 + (0.1 * ( 5 - i ))
        dot.enter(delay * this.motion_clamp) 
      })
      done()
    },

    leave(el, done){
      [
        this.$refs.dotOne,
        this.$refs.dotTwo,
        this.$refs.dotThree,
        this.$refs.dotFour,
        this.$refs.dotFive,
        this.$refs.dotSix
      ].forEach( dot => {
        dot.leave()
      })
      done()
    }
  },

  watch: {

  },

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#pagination
  height: 100%
  position: absolute
  justify-content: center
  display: flex
  align-items: center
  flex-direction: column
  padding: 0
  z-index: 4
  justify-content: flex-end
  right: 3.5rem
  padding: 13rem 0 100px
  width: 45px
  pointer-events: none

  .button
    pointer-events: auto


  @media all and (max-width: $bp-mobile)
    display: none


</style>
